let objConfig = {
    "allItem":{
        "manageErea":{ //首页item权限配置
            "1285514644427800576":{
                "visible":"2345",
            },
            "1285514741995700224":{
                "visible":"2345",
            },
            "1285514855199965184":{
                "visible":"2345",
            },
            "1285514944580583424":{
                "visible":"2345",
            },
            "1285515083814699008":{
                "visible":"2345",
            },
            "1285515383799709696":{
                "visible":"2345",
            },
        },
    },
    "sympathy": {
        "approveStartEnglish": {
            "notstarted": "未开始",
            "agree": "同意",
            "turn": "驳回",
            "revoke": "撤销",
            "audit": "待审核",
            "termination": "终止",
        },
        "approveStartEnglishTitle": {
            "notstarted": { //"未开始"
                "title": "审核中",
                "style": "",
            },
            "audit": { //待审核
                "title": "审核中",
                "style": "",
            },
            "agree": {//"同意"
                "title": "审核通过",
                "style": "",
            },
            "turn": {//"驳回"
                "title": "审核未通过",
                "style": "red",
            },
        },
        "approveStart": {
            "1": {
                "title": "待审核",
                "showTitle": "待审核",
                "style": "noheight",
            },
            "2": {
                "title": " 流转中",
                "showTitle": "流转中",
                "style": "noheight",
            },
            "3": {
                "title": "审核通过",
                "showTitle": "已审核",
                "style": "height",
                "imgUrl": require('../../assets/images/adopt.png')
            },
            "4": {
                "title": "审核不通过",
                "showTitle": "已审核",
                "style": "height",
                "imgUrl": require('../../assets/images/noAdopt.png')
            }
        },
        "start": {
            "1": {
                "title": "审核通过",
                "showTitle": "已审核",
                "style": "height",
            },
            "2": {
                "title": "审核不通过",
                "showTitle": "已审核",
                "style": "height",
            },
            "3": {
                "title": "完成",
                "": "",
                "style": "",
            },
            "4": {
                "title": "待审核",
                "showTitle": "待审核",
                "style": "noheight"
            },
            "5": {
                "title": "流转中",
                "showTitle": "流转中",
                "style": "noheight"
            }
        },
        "rescue": { //大病救助
            "title": "大病救助",
            "type": "3",
        },
        "subsidy": { //困难补助
            "title": "困难补助",
            "type": "4",
        },
        "sympathy": {//其他慰问
            "type": "5",
            "title": "其他慰问",
            "sympathyType": [
                {
                    value: "1",
                    label: "意外伤害"
                },
                {
                    value: "2",
                    label: "其他"
                }
            ]
        },
        "hospitalization": {
            "type": "1",
            "title": "住院慰问申请",
            "hospitalizationType": [
                //住院类型
                // {
                //     value: "1",
                //     label: "生育"
                // },
                // {
                //     value: "2",
                //     label: "疾病"
                // }

            ]
        },
        "death": { //亲属去世
            "type": "2",
            "title": "亲属去世",
            "deathType": [
                //申请补助事由
                {
                    value: "1",
                    label: "父亲去世"
                },
                {
                    value: "2",
                    label: "母亲去世"
                },
                {
                    value: "3",
                    label: "爱人去世"
                },
                {
                    value: "4",
                    label: "子女去世"
                }
            ]
        }
    },
    "userInfo": {//基础人员信息
        "station": { //岗位枚举
            "doctor": "医生",
            "nurse": "护士",
            "medical": "医技",
            "other": "其他",
        },
        "doctorTitle": { //职称
            "0": "正高",
            "1": "副高",
            "2": "中级",
            "3": "初级",
            "4": "其他"
        },
        "userInfoStatus": { //会员状态
            "0": "在职",
            "1": "离职",
            "2": "返聘",
            "3": "退休"
        },
        "identity": { //会员身份
            "1": "工会员工",
            "2": "分会组长",
            "3": "分会管理",
            "4": "工会管理",
            "5": "系统管理员"
        },
    }
}
export default objConfig